import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

export function trackCountrysideTrapClick(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер "Попробуйте искать по поселкам"',
        trapid: 'Баннер "Попробуйте искать по поселкам"',
        source,
      },
    },
    sc: jsonQuery,
  });
}

export function trackCountrysideTrapShow(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер "Попробуйте искать по поселкам"',
        trapid: 'Баннер "Попробуйте искать по поселкам"',
        source,
      },
    },
    sc: jsonQuery,
  });
}
